// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class FeedbackController {
   $scope: any
   alerts: any
   feedback: any
   translationService: any
   constructor($scope: any, feedback: any, config: any, alerts: any, translationService: any) {
      this.sendFeedback = this.sendFeedback.bind(this)
      this.success = this.success.bind(this)
      this.error = this.error.bind(this)
      this.$scope = $scope
      this.feedback = feedback
      this.alerts = alerts
      this.translationService = translationService
      const feedbackConfig = config.data.feedback
      this.$scope.feedback = this.feedback.scope
      this.$scope.emailRequired = feedbackConfig.emailRequired
      this.$scope.enableFeedbackRoles = feedbackConfig.enableFeedbackRoles
      this.$scope.emailPlaceHolder = this.$scope.emailRequired ?
         this.translationService.translations.REQUIRED
         :
         this.translationService.translations.OPTIONAL

      // set modal 'hide' method to feedback 'hide' method so it doesn't get stomped over by other modals (i.e. 'help' modal)
      this.$scope.hide = this.$scope.$hide
      this.$scope.feedbackTypes = this.feedback.feedbackTypes()
      this.$scope.userRoles = this.feedback.userRoles()
      this.$scope.sendFeedback = _.debounce(this.sendFeedback, 500, true)
      this.$scope.isSending = false
   }

   sendFeedback() {
      if(!this.$scope.enableFeedbackRoles){
         this.$scope.feedback.role = ''
      }

      if (!this.$scope.isSending && !!this.$scope.feedbackForm.$valid) {
         this.alerts.resetAlert('feedbackError')
         this.$scope.isSending = true     

         return this.feedback.send()
            .then(this.success)
            .catch(this.error)
      }
   }

   success(response: any) {
      this.$scope.close()
      return response
   }

   error(response: any) {
      const msg = (() => { switch (response.status) {
         case ((response?.data != null) && 422): return response.data
         default: return 'Feedback processing error.'
      } })()
      this.alerts.setAlert('feedbackError', msg)
      return this.$scope.isSending = false
   }
}


angular.module('summonApp.controllers')
   .controller('FeedbackCtrl', ['$scope', 'feedbackService', 'configService', 'alertService', 'translationService', FeedbackController])
